// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1fGdr","inputWrap":"Table_inputWrap__Naf_m","col":"Table_col__1ywMI","bmiTooltip":"Table_bmiTooltip__C_iOg"};